module.exports = __webpack_public_path__ + "static/media/events.b51235d7.jpeg";